<template>
  <div class="page-index">
    <img src="../../static/images/indexNq-share.jpg" height="300" width="300" style="display:none;">
    <p class="picSource">图片来源:123RF正版图库</p>
    <!-- 标题 -->
    <div class="titles">
      <div class="title_pic"></div>
      <div class="title_en"></div>
    </div>
    <!-- 标题 -->
    <!-- 没做过题：选择性别 -->
    <ul class="setSex" v-if="isTested == 0">
      <li class="setSex_male"><a href="javascript:;"
        @click="answerSex('1')" >男生入口</a>
      </li>
      <li class="setSex_female"><a href="javascript:;"
        @click="answerSex('2')">女生入口</a>
      </li>
    </ul>
    <!-- 没做过题：选择性别 -->
    <!-- 做过题了：重做|查看报告 -->
    <ul class="testedMenu" v-if="isTested == 1">
      <!-- 我要重做 -->
      <li class="resetIstested" @click="redoDialog()"><a href="javascript:;"></a></li>
      <!-- 查看我的报告 -->
      <li class="checkReport" @click="checkReport()"><a href="javascript:;"></a></li>
    </ul>
    <!-- 做过题了：重做|查看报告 -->
    <!-- 壹心理Logo -->
    <yxl-logo></yxl-logo>
    <!-- 壹心理Logo -->
    <!-- 重做提示 -->
    <div class="redoDialog" v-if="redoDialogShow">
      <div class="redoMask">!</div>
      <div class="dialog">
        <h1>WARNING</h1>
        <p>新的测试报告将会覆盖原来的测试结果，这可能会导致您重复付费，确定要再测一次吗？</p>
        <div class="actions">
          <a href="javascript:;" class="btn" @click="redo()">再测一次</a>
          <a href="javascript:;" class="btn" @click="redoDialog()">容朕想想</a>
        </div>
      </div>
    </div>
    <!-- 重做提示 -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { mapMutations } from 'vuex'
import { mapActions } from 'vuex'
import router from '../router.js'
import logo from '../components/yxl-logo.vue'
import qrcodeMask from '../components/qrcodeMask.vue'

export default {
  name: 'IndexPage',
  created(){
    if(this.$route.query.channel_id) {
      this.setChannelId(this.$route.query.channel_id);
    }
    if(this.GetQueryString("channel_id")) {
      this.setChannelId(this.GetQueryString("channel_id"));
    }
  },
  mounted() {
    this.pullQuestion(this.getObjLength);
    this.pullIstested();

    document.querySelector('.page-index').style.minHeight = window.screen.availHeight - 45 + 'px';

    document.title = '你是萌兽，还是猛兽？';
    this.$data.oldUnlock = this.shareLock+'';
    // 微信分享
    var that = this;
    wx.ready(function() {
      wx.onMenuShareAppMessage({
        title: '你是萌兽，还是猛兽？', // 分享标题
        desc: '超准的心理测试，用动物看出你真正的性格！',
        link: 'http://static.xinli001.com/animalPicture/index.html', // 分享链接
        imgUrl: "http://static.xinli001.com/animalPicture/static/images/indexNq-share.jpg", // 分享图标
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
          zhuge.track('测评活动', {
              '被分享页面' : '首页或答题页',
          });
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        }
      });

      wx.onMenuShareTimeline({
        title: '你是萌兽，还是猛兽？', // 分享标题
        link: 'http://static.xinli001.com/animalPicture/index.html', // 分享链接
        imgUrl: "http://static.xinli001.com/animalPicture/static/images/indexNq-share.jpg", // 分享图标
        success: function () {
          zhuge.track('测评活动', {
              '被分享页面' : '首页或答题页',
          });
        },
        cancel: function () {
            // 用户取消分享后执行的回调函数
        }
      });

      wx.hideMenuItems({
        menuList: [
          'menuItem:share:qq',
          'menuItem:share:weiboApp',
          'menuItem:share:QZone',
          "menuItem:openWithSafari",
          "menuItem:copyUrl"
        ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
      });

    })

  },
  data() {
    return {
      redoDialogShow: 0,
      oldUnlock: 0,
    }
  },
  components: {
    yxlLogo:logo,
    qrcodeMask: qrcodeMask
  },
  methods: {
    ...mapActions([
      'pullQuestion',
      'pullIstested'
    ]),
    ...mapMutations ([
      'setSex',
      'setIstested',
      'emptyReport',
      'setStayFun',
      'setChannelId'
    ]),
    redoDialog() {
      this.$data.redoDialogShow = !this.$data.redoDialogShow;
    },
    redo() {
      this.$data.isTested = 0;
      this.setIstested(0);
      this.$data.redoDialogShow = 0;
      this.emptyReport();
    },
    checkReport() {
      this.setStayFun(false);
      router.push({
        path: '/funreport',
        name: 'funreport',
        query: {
          channel_id: this.channel_id
        }
      })
    },
    answerSex(str) {
      this.setSex(str);
      router.push({
        name:'question',
        params:{
          questionId: 1
        },
        query: {
          channel_id: this.channel_id
        }
      });
    },
  },
  computed: {
    sex() {
      return this.$store.state.sex
    },
    isTested(){
      return this.$store.state.isTested
    },
    ...mapState({
      stayFun: state => state.stayFun,
      channel_id: state => state.channel_id
    })
  }
}
</script>

<style scoped lang="scss">
$font-size-base:32; // Base on 320rem * 0.5;
@function topx($rem) {
  @return $rem/$font-size-base;
}
.page-index {
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('../../static/images/all_bg.png');

  .picSource {
    margin-top: topx(20rem * 0.5);
    color: #a0a0a0;
    font-size: topx(18rem * 0.5);
    text-align: center;
  }

  .titles {
    .title_pic {
      margin: topx(100rem * 0.5) auto 0 auto;
      width: topx(325rem * 0.5);
      height: topx(57rem * 0.5);
      background: url('../../static/images/index-title_pic.png');
      background-size: cover;
    }
    .title_en {
      margin: topx(30rem * 0.5) auto 0 auto;
      width: topx(447rem * 0.5);
      height: topx(129rem * 0.5);
      background: url('../../static/images/index-title_en.png');
      background-size: cover;
    }
  }

  .setSex {
    overflow: hidden;
    margin-top: topx(115rem * 0.5);
    li {
      float: left;
      &.setSex_male {
        margin-left: topx(54rem * 0.5);
        a {
          background: url('../../static/images/index-setMale.png') no-repeat;
          background-size: topx(160rem * 0.5);
        }
      }
      &.setSex_female {
        float: right;
        margin-right: topx(54rem * 0.5);
        a {
          background: url('../../static/images/index-setFemale.png') no-repeat;
          background-size: topx(160rem * 0.5);
        }
      }
      a {
        display: block;
        min-width: topx(160rem * 0.5);
        padding-top: topx(180rem * 0.5);
        font-size: topx(28rem * 0.5);
        color: #252323;
        font-weight: bold;
        text-align: center;
      }
    }
  }

  .testedMenu {
    margin-top: topx(115rem * 0.5);
    li {
      float: left;
      display: block;
      width: topx(168rem * 0.5);
      height: topx(67rem * 0.5);
      a {
        display: block;
        width: topx(168rem * 0.5);
        height: topx(65rem * 0.5);
      }
    }
    .resetIstested {
      margin-left: topx(107rem * 0.5);
      background: url('../../static/images/index_resetIstested.png') no-repeat;
      background-size: topx(168rem * 0.5) topx(65rem * 0.5);
    }
    .checkReport {
      float: right;
      margin-right: topx(107rem * 0.5);
      background: url('../../static/images/index_checkReport.png') no-repeat;
      background-size: topx(168rem * 0.5) topx(65rem * 0.5);
    }
  }

  .redoDialog {
    .redoMask {
      position: fixed;
      z-index: 99;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: #000;
      opacity: .75;
    }
    .dialog {
      width: topx(437rem * 0.5);
      position: fixed;
      z-index: 99;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      border-radius: topx(30rem * 0.5);
      overflow: hidden;
      h1 {
        margin: topx(20rem * 0.5) topx(70rem * 0.5) 0 topx(70rem * 0.5);
        color: #000000;
        font-size: topx(30rem * 0.5);
        line-height: topx(40rem * 0.5);
        text-align: center;
      }
      p {
        margin: topx(16rem * 0.5) topx(70rem * 0.5) 0 topx(70rem * 0.5);
        color: #000000;
        font-size: topx(24rem * 0.5);
        line-height: topx(42rem * 0.5);
        text-align: left;
      }
      .actions {
        margin-top: topx(25rem * 0.5);
        text-align: center;
        font-size: 0;
        border-top: topx(1rem * 0.5) solid #e4af22;
        a {
          display: inline-block;
          box-sizing: border-box;
          width: 50%;
          height: topx(67rem * 0.5);
          line-height: topx(67rem * 0.5);
          font-size: topx(24rem * 0.5);
          color: #876a19;
          background: #edcb6f;
          border-left: topx(1rem * 0.5) solid #e4af22;
          &:first-child {
            border-left: topx(0rem * 0.5) solid #e4af22;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// Index.vue?52b8e6f4